import { render, staticRenderFns } from "./TaskCompleted.vue?vue&type=template&id=0049ede1&scoped=true"
import script from "./TaskCompleted.vue?vue&type=script&lang=js"
export * from "./TaskCompleted.vue?vue&type=script&lang=js"
import style0 from "./TaskCompleted.vue?vue&type=style&index=0&id=0049ede1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049ede1",
  null
  
)

export default component.exports